export const selectExpandedRecommendations = state => state.betslip.preferences.expandedRecommendations;
